import * as React from 'react';
import { useCallback } from 'react';
import { cn, handlePastePlain } from '@/lib/utils';
type InputProps = Omit<React.ComponentProps<'input'>, 'className'> & {
  error?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  inputClassName?: string;
  containerClassName?: string;
  helperText?: string | Array<string>;
};

function Input({ type, error, startIcon, endIcon, inputClassName, containerClassName, helperText, ...props }: InputProps) {
  const handlePasteAsPlain = useCallback(handlePastePlain, []);
  return (
    <div className="w-full space-y-1">
      <div
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex w-full min-w-0 rounded-sm border bg-transparent text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-input/10 md:text-sm',
          'focus:border-info-I-main focus-visible:border-info-I-main border transition-colors duration-200 focus-visible:border-2 focus-within:border-info-I-main focus-within:border-2',
          'aria-invalid:border-error-E-main dark:aria-invalid:border-error-E-main',
          error && 'border-error-E-main bg-error-E-main/20',
          'flex w-full items-center gap-0.5 my-auto',
          containerClassName
        )}
      >
        {startIcon && <div className="text-muted-foreground">{startIcon}</div>}
        <input
          type={type}
          data-slot="input"
          {...props}
          className={cn("w-full flex-1 border-none outline-none bg-transparent p-1 px-4 rounded-xs", inputClassName)}
          onPaste={handlePasteAsPlain}
        />
        {endIcon && <div className="text-muted-foreground">{endIcon}</div>}
      </div>
      <span
        className={`text-error-E-main font-inter px-2 text-[12px] font-semibold ${error ? 'block' : 'hidden'}`}
      >
        {Array.isArray(helperText) ? (
          <ul className="list-inside list-disc">
            {helperText.map((err) => (
              <li key={err}>{err}</li>
            ))}
          </ul>
        ) : (
          helperText
        )}
      </span>
    </div>
  );
}

export { Input };
